<script>
export default {
    name: 'Offering',
    props: {
        id: { type: Number, default: null },
        title: String,
        description: String,
        organisation: String,
        link: String,
        featured: Boolean,
        status: { type: String, default: null },
        editMode: { type: Boolean, default: false },
    },
    data: () => {
        return {
            showDescription: false,
        }
    },
    methods: {
        toggleDescription() {
            this.showDescription = !this.showDescription;
        },
        onEdit() {
            this.$router.push(this.$route.path + '/offering/edit/' + this.id);
        },
        onDelete() {
            this.$router.push(this.$route.path + '/offering/delete/' + this.id);
        }
    },
    computed: {
        statusLabel() {
            return this.status === 'draft' ? this.$t('offering.statusDraft') : '';
        },
    }
};
</script>

<template>
    <article class="offering" v-bind:class="[{ 'offering--featured': featured }, { 'offering--editable': editMode }]">
        <div class="offering__content">
            <h1 class="offering__title">
                <span v-html="title"></span>
                <span class="offering__status" v-if="statusLabel">{{statusLabel}}</span>
            </h1>
            <p class="offering__description" v-if="description && showDescription">{{ description }}</p>
            <p class="offering__organisation">{{ organisation }}</p>
            <a v-bind:href="link" class="offering__link read-more" target="_blank">{{ $t('offering.moreInfo')}}</a>
            <button 
                class="offering__description-toggle"
                v-if="description" 
                v-on:click="toggleDescription" 
                v-bind:class="{'offering__description-toggle--open': showDescription}">
            </button>
            <ul class="offering__actions" v-if="editMode">
                <li class="offering__action">
                    <button class="offering__action-btn offering__action-btn--edit" v-on:click="onEdit()"></button>
                </li>
                <li class="offering__action">
                    <button class="offering__action-btn offering__action-btn--delete" v-on:click="onDelete()"></button>
                </li>
            </ul>
        </div>
    </article>
</template>

<style lang="scss" scoped>
.offering {
    position: relative;
    box-sizing: border-box;
    min-height: 11.6rem;
    padding: 0.96rem 0 3.2rem;
    border-bottom: 0.1rem solid rgba($color-primary, .15);
}
.offering__content {
    max-width: 56rem;

    @include breakpoint('sm-down') {
        padding-right: 3.2rem;
    }
}
.offering--editable .offering__content {
    padding-right: 12rem;
}
.offering__title {
    font-size: 2.08rem;
    font-weight: normal;
    letter-spacing: 0.057rem;
    line-height: 1.1;
    margin: 0 0 0.32rem;
}
.offering__status {
    display: inline-block;
    margin: 0 0.64rem;
    padding: 0.192rem 0.48rem;
    font-size: 1.4rem;
    text-transform: uppercase;
    letter-spacing: 0.08rem;
    vertical-align: middle;
    color: $color-light;
    background: $color-primary;
}
.offering__description {
    margin: 0 0 0.96rem;
}
.offering__organisation {
    margin: 0;
    opacity: .75;
}
.offering__link read-more {
    display: block;
    margin: 1.28rem 0 0;
}

.offering__description-toggle {
    position: absolute;
    top: 1.6rem; right: 0;
    width: 3.36rem; height: 3.36rem;
    margin: -1.68rem 0;
    border: none;
    outline: none;
    background: center url(~@/assets/images/ico-chevron-bottom-gray.svg) no-repeat;
    cursor: pointer;
}
.offering__description-toggle--open {
    transform: rotate(180deg);
}

.offering__actions {
    position: absolute;
    top: 0.96rem; right: 4rem;
    display: flex;
    margin: 0 -0.4rem;
    padding: 0;
}
.offering__action {
    display: block;
    margin: 0 0.4rem
}
.offering__action-btn {
    width: 2.4rem; height: 2.4rem;
    outline: none;
    border: none;
    margin: 0;
    padding: 0;
    background: center transparent no-repeat;
    cursor: pointer;
}
.offering__action-btn--edit {
    background-image: url('~@/assets/images/ico-edit.svg');
}
.offering__action-btn--delete {
    background-image: url('~@/assets/images/ico-delete.svg');
}
</style>
